module.exports = __webpack_public_path__ + "static/media/015 I GUERRA M_Cimitero monum.939f4908.svg";